import { constants } from "../config";

export const asset = (path: string) => {
    return constants.STATIC_HOST + path;
};
